const { find } = require('lodash');

class SearchNavigationController {
    constructor($scope, $state, breakpointsService, searchService, multisearchService) {
        this.$scope = $scope;
        this.$state = $state;

        this.breakpointsService = breakpointsService;
        this.searchService = searchService;
        this.multisearchService = multisearchService;
    }

    $onInit() {
        this.isCategoriesExpanded = this.filter ? !!find(this.filter.filters, f => f.Key === 'Category') : !this.breakpointsService.isInSmallFormat;
        this.isMultisearch = this.multisearchService.isSearchMultisearch();
        this.searchTerms = this.isMultisearch ? this.multisearchItems.split(',') : [this.searchTerm];
    }

    $onChanges(changes) {
        if (changes.filter && !changes.filter.isFirstChange()) {
            // This is a hack to update active styles on navigation links.
            // Because search state has `reloadOnSearch: false` it does not trigger
            // $stateChangeSuccess event whenver the query params change. ui-sref-active
            // listens for $stateChangeSuccess in order to update itself. This means the
            // nav links do not get highlighted correctly without this.
            //
            // As long as no children of this scope depend on this event being real this
            // should be safe.
            this.$scope.$broadcast('$stateChangeSuccess');
        }
    }

    getMultisearchParam() {
        return this.multisearchItems
            ? `'${this.multisearchItems}'`
            : 'undefined';
    }

    shouldShowCategories() {
        return (this.$state.includes('shop.search.products') || this.$state.includes('shop.search.specials')) && this.searchService.categories.length > 0;
    }

    isActiveCategory(category) {
        const categoryFilter = this.filter ? this.filter.filters.find(f => f.Key === 'Category') : {};

        return category.NodeId === (categoryFilter && categoryFilter.Items ? categoryFilter.Items[0].Term : null);
    }

    toggleCategories() {
        this.isCategoriesExpanded = !this.isCategoriesExpanded;
    }
}

SearchNavigationController.$inject = ['$scope', '$state', 'BreakpointsService', 'SearchService', 'SearchMultisearchService'];

const searchNavigationComponentDefinition = {
    bindings: {
        searchTerm: '<',
        multisearchItems: '<',
        filter: '<',
        disableNavigationLinks: '<',
    },
    controller: SearchNavigationController,
    template: require('./search-navigation.component.html').trim(),
};

module.exports = {
    SearchNavigationController,
    searchNavigationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/search/search-navigation.component.js